export default [
    {
        path: "bespeak/custom",
        name: "bespeakCustom",
        component: () =>
            import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/custom"),
    },
    {
        path: "bespeak/custom/update/:type",
        name: "bespeakCustomUpdate",
        component: () =>
            import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/update"),
    },
    {
        path: "bespeak/custom/query",
        name: "bespeakCustomQuery",
        component: () =>
            import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/detail"),
    },
    {
        path: "bespeak/agent",
        name: "bespeakAgent",
        component: () =>
            import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/agent"),
    },
    {
        path: "bespeak/agent/update/:type",
        name: "bespeakAgentUpdate",
        component: () =>
            import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/update"),
    },
    {
        path: "bespeak/agent/query",
        name: "bespeakAgentQuery",
        component: () =>
            import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/detail"),
    },
    // {
    //     path: "bespeak/manage",
    //     name: "bespeakManage",
    //     component: () => import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/manage"),
    // },
    {
        path: "bespeak/manage/update/:type",
        name: "bespeakManageUpdate",
        component: () =>
            import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/update"),
    },
    {
        path: "bespeak/manage/query",
        name: "bespeakManageQuery",
        component: () =>
            import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/detail"),
    },
    // 卡车预约
    {
        path: "bespeak/truck/list",
        name: "bespeakTruck",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/truckReservate/index"
            ),
    },
    {
        path: "bespeak/truck/update/:type",
        name: "bespeakTruckUpdate",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/truckReservate/update"
            ),
    },
    //卡车预约客户端
    {
        path: "bespeak/truckclient/list",
        name: "bespeakTruckClient",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/truckReservateClient/index"
            ),
    },
    {
        path: "bespeak/truckclient/update/:type",
        name: "bespeakTruckClientUpdate",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/truckReservateClient/update"
            ),
    },
    // 卡车地址薄：发货、收货
    {
        path: "bespeak/delivery/list",
        name: "addressdeliveryList",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/addresslist/delivery/index"
            ),
    },
    {
        path: "bespeak/delivery/update/:type",
        name: "addressdeliveryUpdate",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/addresslist/delivery/update"
            ),
    },
    {
        path: "bespeak/receive/list",
        name: "addressreceiveList",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/addresslist/receive/index"
            ),
    },
    {
        path: "bespeak/receive/update/:type",
        name: "addressreceiveUpdate",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/addresslist/receive/update"
            ),
    },
    // 加价率
    {
        path: "bespeak/markuprate/list",
        name: "markupRateList",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/markupRate/index"
            ),
    },
    //加价率编辑
    {
        path: "bespeak/markuprate/update/:type",
        name: "markupRateUpdate",
        component: () =>
            import(
                /* webpackChunkName: "bespeak" */ "@/views/bespeak/markupRate/update"
            ),
    },

    // 预约单日历
    {
        path: "bespeak/manage",
        name: "reservationList",
        component: () => import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/reservation/index"),
    },
    // 基础设置配置
    {
        path: "bespeak/dataconfig/list",
        name: "dataconfigList",
        component: () => import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/dataconfig/index"),
    },
    {
        path: "bespeak/dataconfig/update/:type",
        name: "dataconfigUpdate",
        component: () => import(/* webpackChunkName: "bespeak" */ "@/views/bespeak/dataconfig/update"),
    },
]